import { render } from "./AllSalesOrders.vue?vue&type=template&id=8785e168"
import script from "./AllSalesOrders.vue?vue&type=script&lang=js"
export * from "./AllSalesOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__